import {Component} from 'react';
import styles from './portal-system-status.component.module.scss';

/**
 * Static system-status pill at the bottom of the portal sidebar.
 * Currently hardcoded as healthy — when a real /status endpoint
 * lands, this component reads it and renders the actual state.
 */
export default class PortalSystemStatus extends Component {
    render() {
        return (
            <div className={styles.pill} role="status" aria-label="System status">
                <span className={styles.dot} aria-hidden="true" />
                <span>All systems operational</span>
            </div>
        );
    }
}
